import { Component, OnInit } from '@angular/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as moment from 'moment';
import { faCheckDouble, faEnvelope, faSave, faCheck } from '@fortawesome/free-solid-svg-icons';


@Component ({
  selector: 'app-serviciosactivos',
  templateUrl: './serviciosactivos.component.html',
  styleUrls: ['./serviciosactivos.component.scss']
})
export class ServiciosactivosComponent implements OnInit {
 
    public fechainicial: any = moment();faCheckDouble: any;
    public faEnvelope;
    public faSave;
    public faCheck;
    public fechafinal: any = moment();;
    public documento:number;
    public concecutivo:number;
    public carga:boolean;

    coinwallet: string[] = ['Antecedentes', 'N.Consulta', 'N.Operador'];
    selectedwallet = this.coinwallet[0];
    
  constructor() {
    this.faCheckDouble = faCheckDouble;
    this.faEnvelope = faEnvelope;
    this.faSave = faSave;
    this.faCheck = faCheck;
  }

  ngOnInit() {
    this.carga = false;
    this.faCheckDouble = faCheckDouble;
    this.faEnvelope = faEnvelope;
    this.faSave = faSave;
    this.faCheck = faCheck;
  }

  buscarServicios(){
    
  }

}
